import * as React from 'react';

import { Mutation } from 'react-apollo';

import ToastActions from 'actions/ToastActions';
import ConfirmDialog from 'components/ConfirmDialog';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import EventTracking from 'lib/EventTracking';

import {
  resendUnclaimedNotifications,
  resendUnclaimedNotificationsVariables,
} from 'organizations/mutations/__generated__/resendUnclaimedNotifications';

import RESEND_UNCLAIMED_NOTIFICATIONS_MUTATION from 'organizations/mutations/ResendUnclaimedNotificationsMutation.gql';

type Props = {
  orgUuid: string;
  groupCount: number;
  onRequestHide: () => void;
};

export default class ResendUnclaimedGroupsNotificationModal extends React.Component<Props> {
  componentDidMount() {
    EventTracking.trackKey(
      'admin_dashboard.class_list.resend_unclaimed_groups_notification_modal.view'
    );
  }
  render() {
    const { groupCount, onRequestHide, orgUuid } = this.props;

    return (
      <Mutation<resendUnclaimedNotifications, resendUnclaimedNotificationsVariables>
        mutation={RESEND_UNCLAIMED_NOTIFICATIONS_MUTATION}
        onCompleted={() => {
          ToastActions.showSuccessToast(
            `The owners of ${groupCount} unclaimed classes have been notified.`
          );
          onRequestHide();
        }}
        onError={() => {
          ToastActions.showErrorToast(
            `Something went wrong! We were unable to notify the class owners. Please try again.`
          );
        }}>
        {resendUnclaimedNotificationMutation => {
          return (
            <ConfirmDialog
              actionButtonText="Notify class owners"
              cancelButtonText="Cancel"
              confirmEventKey="admin_dashboard.class_list.resend_unclaimed_groups_notification_modal.confirm_button.click"
              size="xsmall"
              onCancel={onRequestHide}
              onConfirm={() =>
                resendUnclaimedNotificationMutation({ variables: { input: { orgUuid } } })
              }
              onRequestHide={onRequestHide}
              title={`Notify the owners of ${groupCount} classes?`}
              subtext={
                <React.Fragment>
                  These class owners will receive an email about their unclaimed classes.{' '}
                  <Link to={LinkConstants.UNCLAIMED_GROUPS} target="_blank">
                    Learn more
                  </Link>
                </React.Fragment>
              }
            />
          );
        }}
      </Mutation>
    );
  }
}
